export default (props, vars) =>
  vars?.['useform2']?.['register']('name', { required: true });
